import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Container = styled(Box)<{ isMenuOpen: boolean }>`
  ${({ theme, isMenuOpen }) => css`
    position: absolute;
    top: 105px;
    left: ${!isMenuOpen ? '110px' : '270px'};
    width: ${!isMenuOpen ? 'calc(100% - 110px)' : 'calc(100% - 270px)'};
    height: calc(100% - 105px);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.6);

    @media (max-width: ${theme.screenSizes.laptop}) {
      top: 105px;
      left: 0;
      width: 100%;
      top: 120px;
      height: calc(100% - 120px);
    }
  `}
`
